import { render, staticRenderFns } from "./PlotlyWrapper.vue?vue&type=template&id=a5b91e8a&"
import script from "./PlotlyWrapper.vue?vue&type=script&lang=js&"
export * from "./PlotlyWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a5b91e8a')) {
      api.createRecord('a5b91e8a', component.options)
    } else {
      api.reload('a5b91e8a', component.options)
    }
    module.hot.accept("./PlotlyWrapper.vue?vue&type=template&id=a5b91e8a&", function () {
      api.rerender('a5b91e8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/PlotlyWrapper.vue"
export default component.exports